import { View, Text, styled } from 'tamagui'
import { useState, type ReactNode } from 'react'

const Header = styled(View, {
  flexDirection: 'row',
  alignItems: 'center',
  paddingHorizontal: 16,
  paddingVertical: 6,
  cursor: 'pointer',
  gap: 4,
  hoverStyle: {
    opacity: 1,
  },
  opacity: 0.8,
  // @ts-expect-error -- web transition
  style: { transition: 'opacity 150ms ease', userSelect: 'none' },
})

const Arrow = styled(Text, {
  fontSize: 10,
  color: '$sidebarMuted',
  width: 12,
  // @ts-expect-error -- web transition
  style: { transition: 'transform 150ms ease' },
})

const CategoryName = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 11,
  fontWeight: '700',
  color: '$sidebarMuted',
  textTransform: 'uppercase',
  letterSpacing: 0.5,
})

interface CategoryGroupProps {
  name: string
  children: ReactNode
  defaultCollapsed?: boolean
}

export function CategoryGroup({ name, children, defaultCollapsed = false }: CategoryGroupProps) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed)

  return (
    <View marginTop={8}>
      <Header onPress={() => setCollapsed(!collapsed)}>
        <Arrow
          // @ts-expect-error -- web transform
          style={{ transform: collapsed ? 'rotate(-90deg)' : 'rotate(0deg)' }}
        >
          ▾
        </Arrow>
        <CategoryName>{name}</CategoryName>
      </Header>
      {!collapsed && children}
    </View>
  )
}
